import type { App, Component } from 'vue';
import { createApp } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import '@helpers/validator-config';
import pinia from '@stores/index';

type CreateVueAppOptions = {
  initSentry?: boolean;
};

const orderedStack: Array<{ name: string; file: string | undefined; dataType: string }> = [];
const seenComponents = new Set<string>();

export function createVueApp(
  rootComponent: Component,
  options: CreateVueAppOptions = {}
): App {
  const app = createApp(rootComponent);

  app.use(pinia);
  app.component('VForm', Form);
  app.component('VField', Field);
  app.component('VErrorMessage', ErrorMessage);

  app.mixin({
    beforeCreate() {
      const name = this.$options.name || 'unnamed';
      const file = this.$options.__file;
      const dataType = typeof this.$options.data;
      const key = `${name}:${file}`;

      orderedStack.push({ name, file, dataType });
      if (!seenComponents.has(key) && dataType !== 'function' && this.$options.data !== undefined) {
        seenComponents.add(key);
        console.error(
          '%c[DATA-FN BUG] Component with non-function data:',
          'color: red; font-weight: bold',
          JSON.stringify({ name, file, dataType })
        );
      }
    }
  });

  if (options.initSentry !== false) {
    import('./sentry')
      .then(({ default: sentry }) => sentry(app))
      .catch(() => {});
  }

  return app;
}
